import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, ShieldCheck } from 'lucide-react';
const COOKIE_KEY = 'uronacht_cookie_consent';
interface CookieBannerProps {
  onNavigateDatenschutz?: () => void;
  forceOpen?: boolean;
  onClose?: () => void;
}
export function CookieBanner({
  onNavigateDatenschutz,
  forceOpen,
  onClose
}: CookieBannerProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (forceOpen) {
      setVisible(true);
      return;
    }
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, [forceOpen]);
  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };
  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'all');
    handleClose();
  };
  const handleNecessary = () => {
    localStorage.setItem(COOKIE_KEY, 'necessary');
    handleClose();
  };
  return <AnimatePresence data-id="element-67">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6" data-id="element-68">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl shadow-slate-900/10 border border-slate-200 p-6 sm:p-8" data-id="element-69">
            <div className="flex flex-col sm:flex-row items-start gap-5" data-id="element-70">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-brand-50 border border-brand-100 flex items-center justify-center" data-id="element-71">
                <Cookie className="w-6 h-6 text-brand-500" data-id="element-72" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-73">
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-74">
                  Wir verwenden Cookies
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-1" data-id="element-75">
                  Wir nutzen Cookies, um Ihnen die bestmögliche Erfahrung auf
                  unserer Website zu bieten. Einige sind technisch notwendig,
                  andere helfen uns, unser Angebot zu verbessern.
                </p>
                {onNavigateDatenschutz && <button onClick={onNavigateDatenschutz} className="text-sm text-brand-500 hover:text-brand-600 hover:underline transition-colors font-medium" data-id="element-76">
                    Mehr erfahren (Datenschutzerklärung)
                  </button>}
              </div>

              <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto flex-shrink-0 pt-2 sm:pt-0" data-id="element-77">
                <button onClick={handleNecessary} className="px-5 py-2.5 rounded-lg border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50 transition-colors whitespace-nowrap" data-id="element-78">
                  Nur notwendige
                </button>
                <button onClick={handleAccept} className="px-5 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-bold hover:bg-slate-800 transition-colors shadow-md whitespace-nowrap flex items-center justify-center gap-2" data-id="element-79">
                  <ShieldCheck className="w-4 h-4" data-id="element-80" />
                  Alle akzeptieren
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}